import {ErrorHandler, Inject, Injectable} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {TranslateService} from "@ngx-translate/core";
import { ApplicationInsightsService } from '../app_insight/applicationinsights.service';
import { MessageService } from 'primeng/api';
import {OKTA_AUTH} from '@okta/okta-angular';
import {OktaAuth} from '@okta/okta-auth-js';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private messageService: MessageService,
                private translateService: TranslateService,
                private applicationInsightsService : ApplicationInsightsService,
                @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth) {
    }

    async handleError(error: Error | HttpErrorResponse) {
        if (error.message.includes('/sw.js')) {
            console.error(error);
            return;
        }
        if (error instanceof HttpErrorResponse) {
            if (error.status === 0) {
                this.messageService.add({
                    severity: 'error',
                    detail: this.translateService.instant('ERROR.SERVER_UNREACHEABLE')
                });
            } else if (error.status === 401) {
                await this._oktaAuth.signInWithRedirect();
            } else {
                // Server error, find matching translation
                const key: string = error.error.message;
                const translation: string = this.translateService.instant(key);
                const message: string = translation == key ? error.error.message : translation;
                this.messageService.add({
                    severity: 'error',
                    detail: message
                });
            }
        } else {
            this.messageService.add({
                severity: 'error',
                detail: error.message ? error.message : error.toString()
            });
        }
        // log errors
        this.applicationInsightsService.logException(error);
        console.error(error);
    }
}


